import { render, staticRenderFns } from "./QTab.vue?vue&type=template&id=4943e75a&scoped=true"
import script from "./QTab.vue?vue&type=script&lang=js"
export * from "./QTab.vue?vue&type=script&lang=js"
import style0 from "./QTab.vue?vue&type=style&index=0&id=4943e75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4943e75a",
  null
  
)

export default component.exports